import React, { useEffect } from "react";
import CommonBanner from "../../components/CommonBanner/CommonBanner";
import "./PrivacyPolicy.scss";
import { privacyPolicyUrl } from "../../helpers/paths";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <CommonBanner
        link={privacyPolicyUrl}
        text="Privacy Policy"
        title="Privacy Policy"
      />
      <section
        className="Privacy_policy_container my_container"
        data-aos="fade"
      >
        <div className="wrapper_section_privacy" data-aos="fade-up">
          <p className="privay_policy_Peragraph head_para">
            By entering this website, the visitor consents to the terms of this
            policy. By submitting his/her Information to KPEPL, the visitor will
            be treated as having given his/her permission for processing the
            same in a manner provided in this policy.
          </p>
        </div>

        <div className="wrapper_section_privacy" data-aos="fade-up">
          <div className="privay_policy_heading">Introduction</div>
          <p className="privay_policy_Peragraph">
            At Kapindra Precision Engineering Private Limited (KPEPL), KPEPL
            respects the privacy of individual/visitor and is committed to take
            reasonable precautions to protect information consisting of Personal
            information and `Sensitive Personal Data or Information’ (SPDI)
            (“Information”) of visitors of this KPEPL website and comply with
            all legal, regulatory and/or contractual obligations related to
            privacy. KPEPL has adopted the “Privacy by Default” principles in
            its approach to data privacy i.e. privacy of data and information is
            upheld first by default.
          </p>
          <p className="privay_policy_Peragraph">
            This policy covers the processing, storage and access to Information
            as required under lawful and/or contractual activities with KPEPL or
            otherwise required in the normal course of business. It describes
            KPEPL’s policies and procedures on the collection, usage and
            disclosure of Information provided/received by natural persons and
            meets the requirements established under:
          </p>
          <p className="privay_policy_Peragraph">
            <ul>
              <li>The Information Technology Act, 2000 – Section 43A;</li>
              <li>
                The Information Technology (Reasonable Security Practices and
                Procedures and Sensitive Personal Information) Rules, 2011.
              </li>
            </ul>
          </p>
        </div>

        <div className="wrapper_section_privacy" data-aos="fade-up">
          <div className="privay_policy_heading">1. Scope</div>
          <p className="privay_policy_Peragraph">
            This policy applies to all visitors of this KPEPL’s website.
          </p>
        </div>

        <div className="wrapper_section_privacy" data-aos="fade-up">
          <div className="privay_policy_heading">
            2. Information covered by this Policy
          </div>
          <p className="privay_policy_Peragraph">
            This policy applies to Information collected and processed by KPEPL
            consisting of following:
          </p>
          <p className="privay_policy_Peragraph">
            {" "}
            2.1 Personal information is information related to a visitor, or a
            combination of pieces of information that could reasonably allow him
            to be identified. Personal information may consist of full name,
            personal contact numbers, residential address, email address, gender
            or date of birth. While information such as date of birth in
            isolation may not be enough to uniquely identify the visitor, a
            combination of full name and date of birth may be sufficient to do
            so.
          </p>
          <p className="privay_policy_Peragraph">
            2.2 Sensitive personal data or information (“SPDI”) is such personal
            information that is collected, received, stored, transmitted or
            processed by KPEPL, consisting of:
          </p>
          <p className="privay_policy_Peragraph">
            <ul>
              <li>Password;</li>
              <li>
                Financial information such as bank account or credit card or
                debit card or other payment instrument details;
              </li>
              <li>Physical, physiological and mental health condition;</li>
              <li>Sexual orientation;</li>
              <li>Medical records and history;</li>
              <li>Biometric information;</li>
              <li>
                Any detail relating to the above personal information categories
                as provided to KPEPL for providing service; and
              </li>
              <li>
                Any of the information received under above personal information
                categories by KPEPL for processing, stored or processed under
                lawful contract or otherwise.
              </li>
            </ul>
          </p>
          <p className="privay_policy_Peragraph">
            Please note that any information that is freely available or
            accessible in public domain or furnished under the Right to
            Information Act, 2005 or any other law for the time being in force
            shall not be regarded as sensitive personal information.
          </p>
        </div>

        <div className="wrapper_section_privacy" data-aos="fade-up">
          <div className="privay_policy_heading">3. Purpose</div>
          <p className="privay_policy_Peragraph">
            KPEPL shall collect and use Information for legitimate business
            purposes in order:
          </p>
          <p className="privay_policy_Peragraph">
            <ul>
              <li>
                That a visitor may download product information, order products
                and take advantage of certain other features of KPEPL’s website;
              </li>
              <li>
                {" "}
                To provide information or interactive services through this
                website, to the visitor’s e-mail address or, where the visitor
                wishes it to be sent by post, to the visitor’s postal address;
              </li>
              <li>
                To seek the visitor’s feedback or to contact the visitor in
                relation to the services offered on KPEPL’s website;
              </li>
              <li>Sexual orientation;</li>
              <li>
                To process orders or applications submitted by the visitor;
              </li>
              <li>
                To administer or otherwise carry out KPEPL’s obligations in
                relation to any agreement that the visitor may have with KPEPL;
              </li>
              <li>
                To anticipate and resolve problems with any goods or services
                supplied to the visitor;
              </li>
              <li>
                To create products or services that may meet the visitor’s
                needs;
              </li>
              <li>
                To process and respond to requests, improve KPEPL’s operations,
                and communicate with visitor/s about KPEPL’s products, services
                and businesses; and
              </li>
              <li>To allow the visitor to subscribe to KPEPL’s news alerts.</li>
            </ul>
          </p>
        </div>

        <div className="wrapper_section_privacy" data-aos="fade-up">
          <div className="privay_policy_heading">
            4. Collection of Information
          </div>
          <p className="privay_policy_Peragraph">
            Only minimum Information required to meet the purposes mentioned in
            this policy shall be collected from the visitor/s. Neither KPEPL nor
            its representatives shall be responsible for the authenticity of
            such Information provided by the visitor/s. As normal business
            practice, KPEPL may collect Information in order to enable the
            secure online authentication, interaction and transaction with
            natural persons. This may include the installation of cookies and
            the collection of other session data.
          </p>
        </div>

        <div className="wrapper_section_privacy" data-aos="fade-up">
          <div className="privay_policy_heading">
            5. Access, Correction of Information and withdrawal of consent
          </div>
          <p className="privay_policy_Peragraph">
            Any modifications / corrections required to the Information can be
            carried out on the website. In the event the visitor is unable to do
            so due to lack of functionality in KPEPL’s website and / or the
            visitor wants to withdraw his / her consent to provide SPDI, he /
            she may contact the Grievanceofficer, the details whereof are
            provided in clause 8 of this policy.
          </p>
        </div>

        <div className="wrapper_section_privacy" data-aos="fade-up">
          <div className="privay_policy_heading">
            6. Retention, Processing and storage of Information:
          </div>
          <p className="privay_policy_Peragraph">
            6.1 KPEPL shall retain Information for only as long as necessary to
            meet legal or regulatory requirements or for legitimate business
            purposes as mentioned in this policy.
          </p>
          <p className="privay_policy_Peragraph">
            6.2 KPEPL has implemented required security practices and standards
            in line with the global standards and have a comprehensive
            documented information security program and policy in place, which
            contains managerial, technical, operational and physical security
            control measures that commensurate with the information assets being
            protected with KPEPL’s nature of business. It is being reviewed
            periodically to keep pace with business, technology and regulatory
            changes.
          </p>
        </div>

        <div className="wrapper_section_privacy" data-aos="fade-up">
          <div className="privay_policy_heading">
            7. Disclosure of Information
          </div>
          <p className="privay_policy_Peragraph">
            7.1 KPEPL shall not use or disclose Information for purposes other
            than as mentioned in this policy, except with the consent of visitor
            providing such Information or as required by law. However, KPEPL may
            be legally required to disclose the Information in the following
            cases:
          </p>
          <p className="privay_policy_Peragraph">
            <ul>
              <li>
                Where the disclosure is necessary for compliance of a legal
                obligation;
              </li>
              <li>
                Where mandated under the law by government agencies to disclose
                such Information.
              </li>
            </ul>
          </p>
          <p className="privay_policy_Peragraph">
            7.2 Where necessary, KPEPL may disclose Information to business
            partners or third parties during the normal course of business for
            the purposes mentioned in this policy. In such cases, KPEPL will
            only share Information related data when KPEPL is assured that:
          </p>
          <p className="privay_policy_Peragraph">
            <ul>
              <li>
                The Information is processed legitimately and appropriately by
                the business partner or third party in line with the established
                consent or in line with legal requirements.
              </li>
              <li>
                The business partner or third party has adopted a reasonable and
                equivalent level of security practices and procedures to ensure
                security of the Information shared.
              </li>
            </ul>
          </p>
        </div>

        <div className="wrapper_section_privacy" data-aos="fade-up">
          <div className="privay_policy_heading">8. Feedback or Concern</div>
          <p className="privay_policy_Peragraph">
            For feedback or concern, if any, kindly contact:{" "}
            <a href="mailto:info@kapindra.com">info@kapindra.com</a>
          </p>
          <p className="privay_policy_Peragraph">Mobility Privacy Policy</p>
          <p className="privay_policy_Peragraph">
            We are committed to protecting the privacy of the users ("you" /
            "your" / "yourself") of this website / Mobile Applications offered
            by us (collectively, "Applications") and have provided this privacy
            policy ("Policy") to familiarize you with the manner in which we use
            and discloses your information collected through the Applications.
            This Policy forms part and parcel of the End User License Agreement
            ("EULA"). Capitalized terms which have been used here but are
            undefined shall have the same meaning as attributed to them in the
            EULA.
          </p>
          <p className="privay_policy_Peragraph">
            The terms of the Policy provided herein govern your use of any and
            all of the Applications and the information accessible on or from
            these Applications. The Policy also lays down how we may collect,
            use and use any information you provide.
          </p>
          <p className="privay_policy_Peragraph">
            We reserve the right, at its discretion, to change, modify, add or
            remove portions of this Policy at any time. We recommend that you
            review this Policy periodically to ensure that you are aware of the
            current privacy practices.
          </p>
        </div>

        <div className="wrapper_section_privacy" data-aos="fade-up">
          <div className="privay_policy_heading">Use Of Information</div>
          <p className="privay_policy_Peragraph">
            1. You may need to provide us with your Personal Information while
            using any of the Applications. The information so provided by you to
            us or otherwise captured by us may be used for a number of purposes
            connected with business operations which may include the following:
          </p>
          <p className="privay_policy_Peragraph">
            <ul>
              <li>Processing orders or applications;</li>
              <li>
                Provisioning of services, testing or improvement of services,
                recommending various products or services;
              </li>
              <li>
                Dealing with requests, enquiries and complaints, customer
                services and related activities;
              </li>
              <li>
                Responding to your queries and fulfilling your requests for
                information regarding the Applications;
              </li>
              <li>
                Notifying you of any new offers or services and sending you
                important information regarding the Applications, changes to any
                of our policies and/or other administrative information;
              </li>
              <li>
                Keeping you informed about the latest content available on the
                Applications and special offers with respect to the same;
              </li>
              <li>
                Conducting internal reviews and data analysis for the
                Applications;
              </li>
              <li>Improving the services and content on the Applications;</li>
              <li>Protecting the integrity of the Applications; and</li>
              <li>
                Responding to judicial process and provide information to law
                enforcement agencies or in connection with an investigation on
                matters related to public safety, as permitted by law.
              </li>
            </ul>
          </p>
          <p className="privay_policy_Peragraph">
            2. Your Personal Information will be kept confidential to the
            maximum possible extent and will be used to support your
            relationship with us, to notify you of any updated information and
            new activities and other related functions offered by us. Any
            personally identifiable information provided by you will not be
            considered as sensitive if it is freely available and / or
            accessible in the public domain. Further, any comments, messages,
            blogs, scribbles etc. posted/uploaded/conveyed/communicated by users
            on the public sections of the Application becomes published content
            and is not considered personally identifiable information subject to
            this Policy.
          </p>
          <p className="privay_policy_Peragraph">
            3. We may use Personal Information to verify whether you are
            entitled to access and use the Applications and the products and
            services made available through the Applications. This Personal
            Information may also be used to enable us to enhance your experience
            of the Applications.
          </p>
          <p className="privay_policy_Peragraph">
            4. Further, with respect to Non-Personal Information automatically
            collected and stored in files, we use this information to understand
            and analyze trends, to administer the Applications, to learn about
            user behaviour on the Applications, and to gather demographic
            information about the user base as a whole. We may use this
            information in its marketing and advertising services. We may also
            use such information to measure traffic patterns on the
            Applications.
          </p>
          <p className="privay_policy_Peragraph">
            If you have questions or concerns about this Policy, please contact
            us at <a href="mailto:info@kapindra.com">info@kapindra.com</a>
          </p>
        </div>

        {/* <ul className="ul_privacy" data-aos="fade-up">
          <li className="li_privacy">
            <p className="li_para_privacy">Lorem ipsum dolor sit amet</p>
          </li>
          <li className="li_privacy">
            <p className="li_para_privacy">
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aliquam
              porro dicta magni error optio.
            </p>
          </li>
          <li className="li_privacy">
            <p className="li_para_privacy">
              Lorem ipsum dolor sit amet consectetur adipisicing.
            </p>
          </li>
          <li className="li_privacy">
            <p className="li_para_privacy">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Odit enim
              labore delectus doloribus porro iste!
            </p>
          </li>
          <li className="li_privacy">
            <p className="li_para_privacy">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda
              vitae eius nihil?
            </p>
          </li>
          <li className="li_privacy">
            <p className="li_para_privacy">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda
              vitae eius nihil?
            </p>
          </li>
        </ul> */}
      </section>
    </>
  );
};

export default PrivacyPolicy;
